import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import CabinShell from './components/CabinShell';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const CabinHomePage = lazy(() => import('./pages/Home'));
const ConfigurePage = lazy(() => import('./pages/Configure'));
const CabinStartPage = lazy(() => import('./pages/Start'));
const CabinTriagePage = lazy(() => import('./pages/Triage'));
const CabinWaitingPage = lazy(() => import('./pages/Waiting'));
const CabinCallPage = lazy(() => import('./pages/Call'));
const CabinExitPage = lazy(() => import('./pages/Exit'));

/** Totem da cabine (F-02 · T-21..T-26) — {codigo}.azanas.tech → /cabine/:subdominio (RN-107). */
const routes: RouteObject[] = [
  {
    path: '/cabine/:subdominio',
    element: <CabinShell />,
    children: [
      { index: true, element: <CabinHomePage /> },
      { path: 'configurar', element: <ConfigurePage /> },
      { path: 'iniciar', element: <CabinStartPage /> },
      { path: 'triagem/:id', element: <CabinTriagePage /> },
      { path: 'espera/:id', element: <CabinWaitingPage /> },
      { path: 'atendimento/:id', element: <CabinCallPage /> },
      { path: 'saida/:id', element: <CabinExitPage /> },
    ],
  },
];
export default routes;
